export default "__VITE_PUBLIC_ASSET__88703a33__"